/**
 * @vuelto-surface
 * mobile: ok
 * desktop: n/a
 * strategy: inherit
 */
import React from 'react';
import { formatArPhoneDisplay } from '@shared/phone';
import { formatLocalDate } from '@shared/vueltoDateTime';
import type { SupplierRecord } from '../../domain/catalogSupplierTypes';
import { TicketListRow } from '../../../shared/ticket/TicketListRow';

type SupplierMasterCardProps = {
  supplier: SupplierRecord;
  onPress: () => void;
};

function formatLocation(supplier: SupplierRecord): string | null {
  const city = supplier.city?.trim();
  const state = supplier.state?.trim();
  if (city && state) return `${city}, ${state}`;
  return city ?? state ?? null;
}

export function SupplierMasterCard({ supplier, onPress }: SupplierMasterCardProps) {
  const metaParts: string[] = [];
  const location = formatLocation(supplier);
  if (location) metaParts.push(location);
  if (supplier.contactPhone?.trim()) {
    metaParts.push(formatArPhoneDisplay(supplier.contactPhone) || supplier.contactPhone.trim());
  }
  if (supplier.code?.trim()) metaParts.push(`Código: ${supplier.code.trim()}`);
  if (supplier.createdAt) metaParts.push(`Creado: ${formatLocalDate(supplier.createdAt)}`);

  const contactLine = supplier.contactName?.trim() ?? supplier.contactEmail?.trim() ?? null;

  return (
    <TicketListRow
      title={supplier.name}
      subtitle={contactLine}
      meta={metaParts.length > 0 ? metaParts.join(' · ') : null}
      statusLabel={supplier.isActive ? 'Activo' : 'Inactivo'}
      statusTone={supplier.isActive ? 'ok' : 'bad'}
      inactive={!supplier.isActive}
      onPress={onPress}
      accessibilityLabel={`Ver detalle de ${supplier.name}`}
    />
  );
}
